<breadcrumb endText="System Lists" [navigations]="breadcrumbNavs" />
<div class="m-5">
  <div class="font-medium text-xl mb-2">
    System Lists
  </div>
  <hr />
  <div class="flex flex-col">
    <button (click)="organizationClick()" class="flex justify-between mt-2 p-3 rounded-[8px] hover:bg-gray-200">
      Organization List
      <fa-icon [icon]="faChevronRight" class="mr-3"/>
    </button>
    <button (click)="subjectClick()" class="flex justify-between mt-2 px-3 p-3 rounded-[8px] hover:bg-gray-200">
      Subject List
      <fa-icon [icon]="faChevronRight" class="mr-3"/>
    </button>
    <button (click)="unitClick()" class="flex justify-between mt-2 p-3 rounded-[8px] hover:bg-gray-200">
      Unit List
      <fa-icon [icon]="faChevronRight" class="mr-3"/>
    </button>
    <button (click)="courseClick()" class="flex justify-between mt-2 p-3 rounded-[8px] hover:bg-gray-200">
      Course List
      <fa-icon [icon]="faChevronRight" class="mr-3"/>
    </button>
  </div>
  </div>
